// The 30-day free trial, from the app's side.
//
// Both calls go to the account functions in geezword-account. Nothing here
// decides anything about access: the server writes the entitlement and the
// listener in AuthContext turns Premium on by itself.
//
// `accountTrialStatus` is the authoritative source for whether this account
// may start a trial. It is not inferred from the entitlement, because an
// entitlement says nothing about a trial that has already finished — and
// "already used" and "never had one" must look different on screen.

import { httpsCallable } from 'firebase/functions'
import { functions } from '../config/firebase'
import { BILLING_MODE } from './access'

export const TRIAL_DAYS = 30

const MESSAGES = {
  'unauthenticated': 'Please sign in first.',
  'permission-denied': 'Please sign in with a verified email address.',
  'already-exists': 'This account has already used its free trial.',
  'failed-precondition': 'This account already has Premium access.',
}

export function trialErrorMessage(err) {
  const code = String(err?.code || '').replace(/^functions\//, '')
  return MESSAGES[code] || 'Something went wrong. Please try again.'
}

export async function fetchTrialStatus() {
  const call = httpsCallable(functions, 'accountTrialStatus')
  const { data } = await call({ mode: BILLING_MODE })
  return data
}

export async function startTrial() {
  const call = httpsCallable(functions, 'accountStartTrial')
  const { data } = await call({ mode: BILLING_MODE })
  return data
}
